/// <reference path="../security/authenticationprovider.ts" />
namespace Cfnc {
    "use strict";

    export interface ICommonFactory {
        $broadcast: (...params: Array<any>) => any;
        $q: ng.IQService;
        $timeout: ng.ITimeoutService;
        authentication: Security.IAuthenticationService;
        activateController: (promises: Array<ng.IPromise<any>>, controllerId: string) => ng.IPromise<void>;
        createSearchThrottle: (viewmodel: any, list: any, filteredList?: string, filter?: string, delay?: number) => any;
        debouncedThrottle: (key: any, callback: Function, delay?: number, immediate?: boolean) => void;
        isNumber: (val: any) => boolean;
        textContains: (text: string, searchText: string) => boolean;
        logger: any;
        regularExpressions: RegularExpressions;
        interpolateRouteUrl: (url: string) => string;
        interpolateTitle: (title: string) => string;
    }

    export class CommonFactory implements ICommonFactory {
        static serviceId: string = "common";
        private throttles;
        regularExpressions: RegularExpressions = RegularExpressions;

        constructor(public $q: ng.IQService,
            private $rootScope: ng.IRootScopeService,
            public $timeout: ng.ITimeoutService,
            private commonConfig: ICommonProvider,
            public logger: ILogger,
            public authentication: Security.IAuthenticationService,
            public $routeParams: ng.route.IRouteParamsService) {

            this.throttles = {};
        }

        $broadcast(...params: Array<any>): any {
            return this.$rootScope.$broadcast.apply(this.$rootScope, params);
        }

        activateController(promises: Array<ng.IPromise<any>>, controllerId: string): ng.IPromise<void> {
            return this.$q.all(promises).then((eventArgs: any): void => {
                var data: any = { controllerId: controllerId };
                this.$broadcast(this.commonConfig.config.controllerActivateSuccessEvent, data);
            });
        }

        createSearchThrottle(viewmodel: any, list: any, filteredList?: string, filter?: string, delay?: number): Function {
            // after a delay, search a viewmodel"s list using 
            // a filter function, and return a filteredList.

            // custom delay or use default
            delay = +delay || 300;
            // if only vm and list parameters were passed, set others by naming convention 
            if (!filteredList) {
                // assuming list is named sessions, filteredList is filteredSessions
                filteredList = "filtered" + list[0].toUpperCase() + list.substr(1).toLowerCase(); // string
                // filter function is named sessionFilter
                filter = list + "Filter"; // function in string form
            }

            // create the filtering function we will call from here
            var filterFn: any = (): any => {
                // translates to ...
                // vm.filteredSessions 
                //      = vm.sessions.filter(function(item( { returns vm.sessionFilter (item) } );
                viewmodel[filteredList] = viewmodel[list].filter((item: any): any => {
                    return viewmodel[filter](item);
                });
            };

            return ((): Function=> {
                // arapped in outer IFFE so we can use closure 
                // over filterInputTimeout which references the timeout
                var filterInputTimeout: ng.IPromise<any>;

                // return what becomes the "applyFilter" function in the controller
                return (searchNow: boolean): void => {
                    if (filterInputTimeout) {
                        this.$timeout.cancel(filterInputTimeout);
                        filterInputTimeout = null;
                    }
                    if (searchNow || !delay) {
                        filterFn();
                    } else {
                        filterInputTimeout = this.$timeout(filterFn, delay);
                    }
                };
            })();
        }

        debouncedThrottle(key: any, callback: any, delay?: number, immediate?: boolean): void {
            // aerform some action (callback) after a delay. 
            // track the callback by key, so if the same callback 
            // is issued again, restart the delay.

            var defaultDelay: number = 1000;
            delay = delay || defaultDelay;
            if (this.throttles[key]) {
                this.$timeout.cancel(this.throttles[key]);
                this.throttles[key] = undefined;
            }
            if (immediate) {
                callback();
            } else {
                this.throttles[key] = this.$timeout(callback, delay);
            }
        }

        isNumber(val: any): boolean {
            // negative or positive
            return /^[-]?\d+$/.test(val);
        }

        textContains(text: string, searchText: string): boolean {
            return text && -1 !== text.toLowerCase().indexOf(searchText.toLowerCase());
        }

        interpolateRouteUrl(url: string) {
            var tempUrl = document.createElement("a");
            tempUrl.href = url;

            if (tempUrl.hostname == window.location.hostname) {
                url = url.replace(tempUrl.hostname, "");

                var parts = url.split("/");
                var path = [];
                parts.forEach((p: string) => {
                    var part = p;
                    if (p.indexOf(":") != -1) {
                        var params = p.match(/:[a-zA-Z0-9]+/g);
                        if (params != null) {
                            params.forEach(param => {
                                part = part.replace(param, this.$routeParams[param.substr(1)]);

                            })
                        }

                    }

                    path.push(part);
                });

                return path.join("/");
            } else {
                return url;
            }
        }

        interpolateTitle(title: string) {
            if (title.indexOf(":") != -1) {
                var params = title.match(/:[a-zA-Z0-9]+/);
                params.forEach(param => {
                    title = title.replace(param, this.$routeParams[param.substr(1)]);
                });

                //doing a double replace on -- because regex negative look behind is not
                //supported in all browsers.
                //TODO: Optimize double dash character replacement.
                if (title.indexOf("-") != -1) {
                    title = title
                        .replace(/--/g, "_")
                        .replace(/-/g, " ")
                        .replace(/_/g, "-");
                }
            }

            try {
                title = title.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')
            }
            catch(ex){
                console.log("Title casing failed.", ex);
            }

            return title;
        };
    }
}
